import { useCallback } from 'react'
import { setMaxBidPrice } from '../../service/nft'
// hooks
import { useActiveWeb3React } from '../'

const useMaxBidPrice = (tokenId: string, nftType?: string | number) => {
  const {chainId} = useActiveWeb3React()
  
  const handleBidPrice  = useCallback(
    async (price: string) => {
      console.log("---price---",price)
      return new Promise(resolve => {
        const param = {
          nftId: +tokenId,
          bidPrice: +price,
          nftType: nftType
        }
        setMaxBidPrice(chainId as number, param, (err: any, d: any) => {
          if (err || d.code !== 0) resolve('')
          if (err) return
          if (d.code !== 0) return
          resolve(d)
        })
      })
    },
    [tokenId, chainId, nftType],
  )

  return { onMaxBidPrice: handleBidPrice }
}

export default useMaxBidPrice
